// extracted by mini-css-extract-plugin
module.exports = {"customInput":"dropdown_customInput__1giMa","errorBorder":"dropdown_errorBorder__2RVq8","inputAreas":"dropdown_inputAreas__2XZN9"};